export default __webpack_public_path__ + "static/bg-345f7c12e43e77c05d28504350741828.jpg";